var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPushButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.5,
    r: 14.5,
    fill: "white",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_562",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 10,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.475 32.5C21.0083 32.5 20.5708 32.4 20.1625 32.2C19.7542 32 19.4083 31.7167 19.125 31.35L13.675 24.425L14.15 23.925C14.4833 23.575 14.8833 23.3667 15.35 23.3C15.8167 23.2333 16.25 23.325 16.65 23.575L18.5 24.7V16.5C18.5 16.2167 18.5958 15.9792 18.7875 15.7875C18.9792 15.5958 19.2167 15.5 19.5 15.5C19.7833 15.5 20.025 15.5958 20.225 15.7875C20.425 15.9792 20.525 16.2167 20.525 16.5V28.3L18.1 26.8L20.7 30.125C20.8 30.2417 20.9167 30.3333 21.05 30.4C21.1833 30.4667 21.325 30.5 21.475 30.5H27C27.55 30.5 28.0208 30.3042 28.4125 29.9125C28.8042 29.5208 29 29.05 29 28.5V24.5C29 24.2167 28.9042 23.9792 28.7125 23.7875C28.5208 23.5958 28.2833 23.5 28 23.5H22.525V21.5H28C28.8333 21.5 29.5417 21.7917 30.125 22.375C30.7083 22.9583 31 23.6667 31 24.5V28.5C31 29.6 30.6083 30.5417 29.825 31.325C29.0417 32.1083 28.1 32.5 27 32.5H21.475ZM15.175 19C14.9583 18.6333 14.7917 18.2375 14.675 17.8125C14.5583 17.3875 14.5 16.95 14.5 16.5C14.5 15.1167 14.9875 13.9375 15.9625 12.9625C16.9375 11.9875 18.1167 11.5 19.5 11.5C20.8833 11.5 22.0625 11.9875 23.0375 12.9625C24.0125 13.9375 24.5 15.1167 24.5 16.5C24.5 16.95 24.4417 17.3875 24.325 17.8125C24.2083 18.2375 24.0417 18.6333 23.825 19L22.1 18C22.2333 17.7667 22.3333 17.5292 22.4 17.2875C22.4667 17.0458 22.5 16.7833 22.5 16.5C22.5 15.6667 22.2083 14.9583 21.625 14.375C21.0417 13.7917 20.3333 13.5 19.5 13.5C18.6667 13.5 17.9583 13.7917 17.375 14.375C16.7917 14.9583 16.5 15.6667 16.5 16.5C16.5 16.7833 16.5333 17.0458 16.6 17.2875C16.6667 17.5292 16.7667 17.7667 16.9 18L15.175 19Z",
    fill: "#EB0203"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushButton);
export default __webpack_public_path__ + "static/media/PushButton.cd2019732c53bf3e2e0e29859f93f69f.svg";
export { ForwardRef as ReactComponent };